import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../../layouts';
import configBase from '../../../../configBase';
import axios from 'axios';
import {DropzoneDialog} from 'material-ui-dropzone';
import InputMask from 'react-input-mask';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Alert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SearchIcon from '@material-ui/icons/Search';


class NovoVendedor extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      brokers: [],
      listSalesman: [],
      brokerId: {value: 'null', required: true, error: '', type: 'text'},
      cpf: {value: '', required: true, error: '', type: 'text'},
      phone: {value: '', required: false, error: '', type: 'text'},
      email: {value: '', required: true, error: '', type: 'email'},
      linkSite: {value: '', required: true, error: '', type: 'text'},
      password: {value: '', required: true, error: '', type: 'password', show: false},
      image: {value: '', required: false, error: '', type: 'file', url: ''},
      chooseSalesmanSelect: {value: 'null', required: true, error: '', type: 'email'},
      name: '',
      codeS4: '',
      validCpf: false,
      loadingCpf: false,
      disabledFields: true,
      editSalesman: false,
      objEditSalesman: null,
      loadingFields: true,
      loadingSave: false,      

      dropzoneDialog: false,
      typeFile: '',

      errorRequest: false,
      msgErrorRequest: '',
      successRequest: false,
      msgSuccessRequest: '',
    };

  }

  componentDidMount() {
    let search = this.props.history.location.search;
    let urlBroker = configBase.api + 'Brokers?filter={"where":{"active":true},"include":"user"}&access_token='+localStorage.getItem('planos_t');

    axios.get(urlBroker)
    .then((response) => {
      let state = this.state;
      state.brokers = response.data.sort(this.compareNameBroker);
      this.setState(state);

      // É uma edição
      if (search.length > 0) {
        let salesman = this.props.history.location.search.replace('?slm=', '');

        if (salesman && salesman.length > 0 && search.indexOf('?slm=') > -1) {
          let url = `${configBase.api}Salesmans/${salesman}?filter={"include":["user",{"broker":"user"}]}&access_token=${localStorage.getItem('planos_t')}`;
          axios.get(url)
          .then((response) => {
            let state = this.state;
            state.objEditSalesman = response.data;
            state.editSalesman = true;
            state.name = response.data.user.name;
            state.email.value = response.data.user.email;
            state.password.required = false;
            state.brokerId.value = response.data.broker.id;
            state.cpf.value = response.data.cpf;
            state.phone.value = response.data.phone;
            state.linkSite.value = response.data.linkSite;
            state.codeS4 = response.data.codeS4;
            state.validCpf = true;
            state.loadingCpf = false;
            state.loadingSave = false;
            state.listSalesman = [{Id: response.data.codeS4, Nome: response.data.user.name}];
            state.chooseSalesmanSelect.value = response.data.codeS4;

            if (response.data.user.image && response.data.user.image.length > 0)
              state.image.url = `${configBase.api}attachments/users/download/${response.data.user.image}`;

            state.disabledFields = false;
            state.loadingFields = false;
            this.setState(state);
          })
          .catch(function () {
            this.setError('Problema encontrado ao buscar dados da vendedor');
          }.bind(this));
        }
        else {
          state.editSalesman = false;
          state.disabledFields = true;
          state.loadingFields = false;
          this.setError('A vendedor não foi identificada corretamente');
        }
      }
      // Não é uma edição
      else {
        state.editSalesman = false;
        state.disabledFields = false;
        state.loadingFields = false;
      }

      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar corretoras');
    }.bind(this));
  }

  compareNameBroker(a, b) {
    let aBroker = a.user.name;
    let bBroker = b.user.name;

    if (aBroker > bBroker)
      return 1;
    if (aBroker < bBroker)
      return -1;
    return 0;
  }

  updateFields(event) {
    let state = this.state;
    state[event.target.name].value = event.target.value;
    state[event.target.name].error = '';
    this.setState(state);
  }

  validateEmail(email) {
    let emailReg=/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    if(!emailReg.test(email))
      return false;
    else
      return true;
  }

  testOnBlurEmail() {
    // Para uma edição
    if (this.state.editSalesman === true) {
      // Só verifica no banco se o email for diferente do já cadastrado
      if (this.state.email.value !== this.state.objEditSalesman.user.email)
        this.onBlurEmail();
    }
    // Para uma nova
    else
      this.onBlurEmail();
  }

  onBlurEmail() {
    if (this.validateEmail(this.state.email.value) === true) {
      let url = `${configBase.api}Accounts/count?where={"email":"${this.state.email.value}"}&access_token=${localStorage.getItem('planos_t')}`;

      axios.get(url)
      .then((response) => {
        let state = this.state;
        // Se encontrar pelo menos um usuário ou mais com mesmo email
        if (response.data.count > 0)
          state.email.error = 'Já existe usuário com mesmo e-mail';
        else
          state.email.error = '';

        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.email.error = 'Problema encontrado ao validar email';
        this.setError('Problema encontrado ao validar email');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.email.error = 'Formato de e-mail incorreto';
      this.setState(state);
    }
  }

  handleClickShowPassword() {
    let state = this.state;
    state.password.show = !state.password.show;
    this.setState(state);
  }

  dropzoneDialogOpen(typeFile=null) {
    if (this.state.disabledFields === false) {
      let state = this.state;
      state.dropzoneDialog = true;

      if (typeFile !== null)
        state.typeFile = typeFile;

      this.setState(state);
    }
  }

  dropzoneDialogClose() {
    let state = this.state;
    state.dropzoneDialog = false;
    this.setState(state);
  }

  fileToBase64(files) {
    let reader = new FileReader();
    let file = files[0];
    let ext = file.name.split('.').pop().toLowerCase();
    let state = this.state;

    state.image.value = ""
    state.image.error = '';

    if (ext === 'pdf')
      state.image.url = "pdf";
    else 
      state.image.url = window.URL.createObjectURL(file);

    this.dropzoneDialogClose();
    
    reader.onloadend = function() {
      let state = this.state;
      state.image.value = reader.result;
      this.setState(state);
    }.bind(this);

    reader.readAsDataURL(file);
  }

  checkField() {
    let fields = ['brokerId', 'cpf', 'phone', 'email', 'linkSite', 'password', 'image', 'chooseSalesmanSelect'];
    let state = this.state;
    let error = false;

    state.loadingSave = true;
    this.setState(state);

    for (let i = 0; i < fields.length; i++) {
      if (state[fields[i]].error.length === 0) {
        if (state[fields[i]].required === true && state[fields[i]].value.replace('null', '').length === 0) {
          error = true;
          state[fields[i]].error = 'Campo obrigatório';
        }
        else
          state[fields[i]].error = '';
      }
      else
        error = true;
    }

    this.setState(state);

    if (error === false) {
      if (this.state.editSalesman === true)
        this.saveEditSalesman();
      else
        this.saveSalesman();
    }
    else {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Preencher os campos de forma correta.');
    }
  }

  stateDefault() {
    let state = this.state;
    state.brokers = [];
    state.listSalesman = [];
    state.brokerId.value = 'null';
    state.cpf.value ='';
    state.phone.value = '';
    state.email.value = '';
    state.linkSite.value = '';
    state.password.value = '';
    state.image.value = '';
    state.chooseSalesmanSelect.value = 'null';
    state.name = '';
    state.codeS4 = '';
    state.validCpf = false;
    state.loadingCpf = false;
    state.loadingSave = false;
    this.setState(state);
  }

  saveSalesman() {
    if (this.state.brokerId.error.length === 0 &&
      this.state.email.error.length === 0 &&
      this.state.phone.error.length === 0 &&
      this.state.linkSite.error.length === 0 &&
      this.state.chooseSalesmanSelect.error.length === 0 &&
      this.state.password.error.length === 0 &&
      this.state.cpf.error.length === 0 &&
      this.state.image.error.length === 0) {
    
      let state = this.state;
      state.loadingSave = true;
      this.setState(state);

      let dataPost = {
        brokerId: this.state.brokerId.value,
        name: this.state.name,
        email: this.state.email.value,
        password: this.state.password.value,
        image: this.state.image.value,
        cpf: this.state.cpf.value,
        phone: this.state.phone.value,
        linkSite: this.state.linkSite.value,
        codeS4: this.state.codeS4,
      };
      let url = configBase.api + 'Salesmans/saveUserSalesman?access_token='+localStorage.getItem('planos_t');
      
      axios.post(url, dataPost)
      .then(() => {
        this.stateDefault();
        this.setSuccess('Vendedor salvo com sucesso');
      })
      .catch(function () {
        let state = this.state;
        state.loadingSave = false;
        this.setError('Problema encontrado ao salvar vendedor');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Preencher os campos de forma correta.');
    }
  }

  saveEditSalesman() {
    if (this.state.brokerId.error.length === 0 &&
      this.state.email.error.length === 0 &&
      this.state.phone.error.length === 0 &&
      this.state.linkSite.error.length === 0 &&
      this.state.chooseSalesmanSelect.error.length === 0 &&
      this.state.password.error.length === 0 &&
      this.state.cpf.error.length === 0 &&
      this.state.image.error.length === 0) {

      let state = this.state;
      state.loadingSave = true;
      this.setState(state);

      let dataPost = {
        brokerId: this.state.brokerId.value,
        cpf: this.state.cpf.value,
        phone: this.state.phone.value,
        linkSite: this.state.linkSite.value,
        codeS4: this.state.codeS4,
        name: this.state.name,
      };
      let dataPost2 = {
        name: this.state.name,
        email: this.state.email.value,
      };

      if (state.password.value.length > 0)
        dataPost2.password = state.password.value;

      let url = configBase.api + 'Salesmans/upsertWithWhere?where={"id":"'+this.state.objEditSalesman.id+'"}&access_token='+localStorage.getItem('planos_t');
      let url2 = configBase.api + 'Accounts/upsertWithWhere?where={"id":"'+this.state.objEditSalesman.user.id+'"}&access_token='+localStorage.getItem('planos_t');

      axios.post(url, dataPost)
      .then(() => {
        axios.post(url2, dataPost2)
        .then(() => {
          // Quando editar a imagem
          if (this.state.image.value.length > 0) {
            let dataPost3 = {
              code: this.state.image.value,
              nameOld: '',
              userId: this.state.objEditSalesman.user.id
            };
            let url3 = configBase.api + 'Attachments/saveImageUser?access_token='+localStorage.getItem('planos_t');

            if (this.state.objEditSalesman.user.image && this.state.objEditSalesman.user.image.length > 0)
              dataPost3.nameOld = this.state.objEditSalesman.user.image;

            axios.post(url3, dataPost3)
            .then(() => {
              let state = this.state;
              state.loadingSave = false;
              this.setSuccess('Vendedor salvo com sucesso');
            })
            .catch(function () {
              let state = this.state;
              state.loadingSave = false;
              this.setError('Problema encontrado ao salvar imagem da vendedor');
            }.bind(this));
          }
          // Não editou a imagem
          else {
            let state = this.state;
            state.loadingSave = false;
            this.setSuccess('Vendedor salvo com sucesso');
          }
        })
        .catch(function () {
          let state = this.state;
          state.loadingSave = false;
          this.setError('Problema encontrado ao salvar vendedor');
        }.bind(this));
      })
      .catch(function () {
        let state = this.state;
        state.loadingSave = false;
        this.setError('Problema encontrado ao editar vendedor');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Preencher os campos de forma correta.');
    }
  }

  backListSalesman() {
    this.props.history.push(`${process.env.PUBLIC_URL}/vendedores`);
  }

  validateCpf() {
    let cpf = this.state.cpf.value.replace(/[^\d]+/g,"");
    let test = true;
    let add = 0, i = 0, rev = 0;
    if (cpf.length !== 11 || 
        cpf === "00000000000" || 
        cpf === "11111111111" || 
        cpf === "22222222222" || 
        cpf === "33333333333" || 
        cpf === "44444444444" || 
        cpf === "55555555555" || 
        cpf === "66666666666" || 
        cpf === "77777777777" || 
        cpf === "88888888888" || 
        cpf === "99999999999"){
      test = false;
    }
    else {
      for (i=0; i < 9; i ++)		
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        rev = 11 - (add % 11);	
        if (rev === 10 || rev === 11){		
          rev = 0;
        }	
        if (rev !== parseInt(cpf.charAt(9))){		
          test = false;          	
        }	
      add = 0;	
      for (i = 0; i < 10; i ++){	
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }	
      rev = 11 - (add % 11);	
      if (rev === 10 || rev === 11){
        rev = 0;
      }	
      if (rev !== parseInt(cpf.charAt(10))){
        test = false;
      }
    }

    let state = this.state;

    if (test === true) {
      state.cpf.error = '';
      state.password.value = cpf.substring(0, 6);
      this.getSalesman(cpf);
    }
    else {
      state.validCpf = false;
      state.cpf.error = 'CPF inválido';
    }

    this.setState(state);
  }

  getSalesman(cpf) {
    let url = configBase.api + 'APIS4s/Adesionistas?access_token='+localStorage.getItem('planos_t');
    let dataPost = {
      'cpf': cpf
    };

    let state = this.state;
    state.validCpf = false;
    state.loadingCpf = true;
    state.chooseSalesmanSelect.value = 'null';
    this.setState(state);

    axios.post(url, dataPost)
    .then((response) => {
      let state = this.state;
      state.loadingCpf = false;

      if (response.data.length > 0) {
        state.validCpf = true;
        state.cpf.error = '';
        state.listSalesman = response.data;
      }
      else {
        state.validCpf = false;
        state.cpf.error = 'Vendedor não localizado no sistema S4E';
        state.codeS4 = '';
        state.name = '';
        state.salesmanS4 = null;
      }

      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.cpf.error = 'Problema ao pesquisar CPF.';
      state.validCpf = false;
      state.loadingCpf = false;
      this.setError('Problema encontrado ao buscar vendedor pelo CPF');
    }.bind(this));
  }

  validateCell() {
    let tel = this.state.phone.value;
    let telLength = tel.replace(/[^0-9]/g, '').length;

    if (telLength > 0) {
      if (telLength !== 11) {
        let state = this.state;
        state.phone.error = 'Número de celular inválido';
        this.setState(state);
      }
    }
  }

  testSalesmanChange(event) {
    let state = this.state;
    state.chooseSalesmanSelect.value = event.target.value;
    state.chooseSalesmanSelect.error = '';
    this.setState(state);

    // Para uma edição
    if (this.state.editSalesman === true) {
      // Só verifica no banco se o código for diferente do já cadastrado
      if (parseInt(event.target.value) !== parseInt(this.state.objEditSalesman.codeS4))
        this.salesmanChange(event);
      else
        this.salesmanChange2(event);
    }
    // Para uma nova
    else
      this.salesmanChange(event);
  }

  salesmanChange(event) {
    let codeSalesman = event.target.value;

    if (codeSalesman !=='null') {
      let url = configBase.api + 'Salesmans?filter={"where":{"codeS4":"'+codeSalesman+'"},"include":{"broker":"user"}}&access_token='+localStorage.getItem('planos_t');

      axios.get(url)
      .then((response) => {
        let state = this.state;
        // Se encontrar pelo menos um vendedor ou mais com mesmo codeS4
        if (response.data.length > 0)
          state.chooseSalesmanSelect.error = 'Vendedor já cadastrado. Corretora: '+response.data[0].broker.user.name;
        else {
          let state = this.state;
          state.chooseSalesmanSelect.error = '';

          for (let i = 0; i < this.state.listSalesman.length; i++) {
            if (parseInt(this.state.listSalesman[i].Id) === parseInt(codeSalesman)) {
              let nameArray = this.state.listSalesman[i].Nome.split(' - ');

              if (nameArray.length > 1) {
                nameArray = nameArray[1].trim().toLowerCase().split(' ');
                state.codeS4 = codeSalesman;
                state.name = this.state.listSalesman[i].Nome;
                state.linkSite.value = nameArray[0] + '-' + nameArray[nameArray.length -1 ];
                break;
              }
              else {
                nameArray = nameArray[0].trim().toLowerCase().split(' ');
                state.codeS4 = codeSalesman;
                state.name = this.state.listSalesman[i].Nome;
                state.linkSite.value = nameArray[0] + '-' + nameArray[nameArray.length -1 ];
                break;
              }
            }
          }
        }

        this.setState(state);
        this.testGetLinkSite();
      })
      .catch(function () {
        let state = this.state;
        state.chooseSalesmanSelect.error = 'Problema ao buscar Vendedor';
        this.setState(state);
      }.bind(this));
    }
    else {
      let state = this.state;
      state.chooseSalesmanSelect.error = 'Campo obrigatório.';
      this.setState(state);
    }
  }

  salesmanChange2(event) {
    // Função para atualizar o vendedor atual na edição
    let codeSalesman = event.target.value;
    let url = configBase.api + 'Salesmans?filter={"where":{"codeS4":"'+codeSalesman+'"},"include":{"broker":"user"}}&access_token='+localStorage.getItem('planos_t');

    axios.get(url)
    .then(() => {
      let state = this.state;
      state.chooseSalesmanSelect.error = '';

      for (let i = 0; i < this.state.listSalesman.length; i++) {
        if (parseInt(this.state.listSalesman[i].Id) === parseInt(codeSalesman)) {
          let nameArray = this.state.listSalesman[i].Nome.split(' - ');

          if (nameArray.length > 1) {
            nameArray = nameArray[1].trim().toLowerCase().split(' ');
            state.codeS4 = codeSalesman;
            state.name = this.state.listSalesman[i].Nome;
            state.linkSite.value = nameArray[0] + '-' + nameArray[nameArray.length -1 ];
            break;
          }
          else {
            nameArray = nameArray[0].trim().toLowerCase().split(' ');
            state.codeS4 = codeSalesman;
            state.name = this.state.listSalesman[i].Nome;
            state.linkSite.value = nameArray[0] + '-' + nameArray[nameArray.length -1 ];
            break;
          }
        }
      }

      this.setState(state);
      this.testGetLinkSite();
    })
    .catch(function () {
      let state = this.state;
      state.chooseSalesmanSelect.error = 'Problema ao buscar Vendedor';
      this.setState(state);
    }.bind(this));
  }

  testGetLinkSite() {
    // Para uma edição
    if (this.state.editSalesman === true) {
      // Só verifica no banco se o email for diferente do já cadastrado
      if (this.state.linkSite.value !== this.state.objEditSalesman.linkSite)
        this.getLinkSite();
    }
    // Para uma nova
    else
      this.getLinkSite();
  }

  getLinkSite() {
    let url = configBase.api + 'Salesmans/count?where={"linkSite":"'+this.state.linkSite.value+'"}&access_token='+localStorage.getItem('planos_t');

    axios.get(url)
    .then((response) => {
      let state = this.state;
      // Se encontrar pelo menos um vendedor ou mais com mesmo linkSIte
      if (response.data.count > 0)
        state.linkSite.error = 'Link de vendas já em uso.';
      else
        state.linkSite.error = '';

      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.linkSite.error = 'Erro ao verificar o Link de Vendas';
      this.setState(state);
    }.bind(this));
  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  setSuccess(msg) {
    let state = this.state;
    state.successRequest = true;
    state.msgSuccessRequest = msg;
    this.setState(state);
  }

  successClose() {
    let state = this.state;
    state.successRequest = false;
    state.msgSuccessRequest = '';
    this.setState(state);
  }


  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="vendedores" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Grid container spacing={0}>
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  {
                    this.state.editSalesman === true ? ('EDITAR VENDEDOR') : ('CADASTRAR VENDEDOR')
                  }
                </Typography>
              </Grid>

              <Grid item xs={12} sm={8} md={8} lg={8} className="botaoTituloAdd">
                <div className="botoesDeEnvio">
                  <Button
                    style={{backgroundColor: '#636d77', color: '#fff', marginRight: 5}}
                    variant="contained"
                    startIcon={<ArrowBackIcon />}
                    size="small"
                    onClick={this.backListSalesman.bind(this)}
                    color="default"
                  >
                    VOLTAR
                  </Button>
                </div>
                <div className="botoesDeEnvio containerButton">
                  <Button
                    variant="contained"
                    style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    startIcon={<SaveIcon />}
                    size="small"
                    onClick={this.checkField.bind(this)}
                    disabled={this.state.loadingSave}
                  >
                    SALVAR
                  </Button>
                  {
                    this.state.loadingSave === true ? (
                  <CircularProgress size={24} className="progressButton" />
                    ) : ('')
                  }
                </div>
              </Grid>
            </Grid>
          </Paper>

          <div id="novovendedorConteudo" className="contentepanel" style={{marginTop: 40}}>
            <Paper className="paperForm">
              <div className="paper">
                <Typography variant="h6" gutterBottom className="titlePaperForm">
                  Informações da Vendedor
                </Typography>
              </div>

              <div>
                <Divider />
              </div>

              <div className="paper">
                <Grid container spacing={0}>
                  <Grid item xs={10} sm={10} md={4} lg={4} className="containerButton">
                    <InputMask
                      mask="999.999.999-99"
                      maskChar=" "
                      value={this.state.cpf.value}
                      onChange={this.updateFields.bind(this)}
                      onBlur={this.validateCpf.bind(this)}
                      disabled={this.state.loadingCpf}
                    >
                      {() => <TextField
                        fullWidth
                        label={this.state.cpf.required === true ? ("CPF *"):("CPF")}
                        variant="outlined"
                        size="small"
                        name="cpf"
                        error={this.state.cpf.error.length > 0 ? (true):(false)}
                        helperText={this.state.cpf.error}
                        disabled={this.state.loadingCpf}
                      />}
                    </InputMask>
                    {
                      this.state.loadingCpf === true ? (
                    <CircularProgress size={24} className="progressButton" />
                      ) : ('')
                    }
                  </Grid>
                  <Grid item xs={2} sm={2} md={2} lg={2} className="containerButton">
                    <IconButton
                      type="submit" aria-label="search" style={{top: -4}}
                      onClick={this.validateCpf.bind(this)}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Grid>
                </Grid>

                {
                  this.state.validCpf === true ? (
                <div>
                  <Grid container spacing={2} style={{marginTop: 40}}>
                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.brokerId.error.length > 0 ? (true):(false)}
                        helperText={this.state.brokerId.error}
                        label={this.state.brokerId.required === true ? ("Corretora *"):("Corretora")}
                        variant="outlined"
                        size="small"
                        name="brokerId"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.brokerId.value}
                        onChange={this.updateFields.bind(this)}
                        disabled={!this.state.validCpf}
                      >
                        <option value="null">Selecione</option>
                      {this.state.brokers.map((item, index) =>
                        <option key={index} value={item.id}>{item.user.name}</option>
                      )}
                      </TextField>

                      {
                        this.state.loadingFields === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                      <TextField
                        fullWidth
                        select
                        error={this.state.chooseSalesmanSelect.error.length > 0 ? (true):(false)}
                        helperText={this.state.chooseSalesmanSelect.error}
                        label={this.state.chooseSalesmanSelect.required === true ? ("Vendedor *"):("Vendedor")}
                        variant="outlined"
                        size="small"
                        name="chooseSalesmanSelect"
                        SelectProps={{
                          native: true,
                        }}
                        value={this.state.chooseSalesmanSelect.value}
                        onChange={this.testSalesmanChange.bind(this)}
                        disabled={!this.state.validCpf}
                      >
                        <option value="null">Selecione</option>
                      {this.state.listSalesman.map((item, index) =>
                        <option key={index} value={item.Id}>{item.Nome}</option>
                      )}
                      </TextField>

                      {
                        this.state.loadingFields === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                      <InputMask
                        mask="(99) \9 9999-9999"
                        maskChar=" "
                        value={this.state.phone.value}
                        onChange={this.updateFields.bind(this)}
                        onBlur={this.validateCell.bind(this)}
                        disabled={!this.state.validCpf}
                      >
                        {() => <TextField
                          fullWidth
                          label={this.state.phone.required === true ? ("Celular *"):("Celular")}
                          error={this.state.phone.error.length > 0 ? (true):(false)}
                          helperText={this.state.phone.error}
                          variant="outlined"
                          size="small"
                          name="phone"
                          disabled={!this.state.validCpf}
                        />}
                      </InputMask>
                      {
                        this.state.loadingFields === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                      <TextField
                        fullWidth
                        error={this.state.email.error.length > 0 ? (true):(false)}
                        helperText={this.state.email.error}
                        label={this.state.email.required === true ? ("E-mail *"):("E-mail")}
                        type={this.state.email.type}
                        variant="outlined"
                        size="small"
                        name="email"
                        value={this.state.email.value}
                        onChange={this.updateFields.bind(this)}
                        onBlur={this.testOnBlurEmail.bind(this)}
                        disabled={!this.state.validCpf}
                      />
                      {
                        this.state.loadingFields === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                      <FormControl
                        variant="outlined" size="small" fullWidth
                        disabled={!this.state.validCpf}
                      >
                        <InputLabel htmlFor="outlined-adornment-password">{this.state.password.required === true ? ("Senha *"):("Senha")}</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={this.state.password.show === true ? ('text') : ('password')}
                          value={this.state.password.value}
                          name="password"
                          onChange={this.updateFields.bind(this)}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={this.handleClickShowPassword.bind(this)}
                                edge="end"
                              >
                                {this.state.password.show ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                          labelWidth={70}
                        />
                      </FormControl>
                      {
                        this.state.loadingFields === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }
                    </Grid>
                  </Grid>

                  <Grid container spacing={1} alignItems="flex-end" style={{marginTop: 10}}>
                    <Grid item xs={12} sm={12} md={12} lg={12} id="i_linkSite" className="containerButton">
                      <TextField
                        id="filled-start-adornment"
                        fullWidth
                        error={this.state.linkSite.error.length > 0 ? (true):(false)}
                        helperText={this.state.linkSite.error}
                        label={this.state.linkSite.required === true ? ("Link de Vendas *"):("Link de Vendas")}
                        type={this.state.linkSite.type}
                        variant="outlined"
                        size="small"
                        name="linkSite"
                        value={this.state.linkSite.value}
                        onChange={this.updateFields.bind(this)}
                        onBlur={this.testGetLinkSite.bind(this)}
                        disabled={!this.state.validCpf}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">{configBase.front+'pessoafisica?vendedor='}</InputAdornment>,
                        }}
                      />

                      {
                        this.state.loadingFields === true ? (
                      <CircularProgress size={24} className="progressButton" />
                        ) : ('')
                      }

                      <style>{`
                      #i_linkSite {
                        margin-top: 5px;
                      }
                      #i_linkSite input {
                        background-color: #fff;
                      }
                      #i_linkSite .MuiOutlinedInput-adornedStart {
                        background-color: #ccc;
                      }
                      #i_linkSite label {
                        top: -4px
                      }
                      `}</style>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} style={{marginTop: 10}}>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <Card>
                        <CardHeader
                          className="title_docs"
                          title="Imagem"
                        />

                        <Divider style={{marginBottom: 10}}/>

                        <CardActionArea
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                          style={{cursor: this.state.disabledFields === true ? ('default') : ('pointer')}}
                        >
                          {
                            this.state.image.url.length > 0 ? (
                              this.state.image.url.substr(this.state.image.url.length - 3, this.state.image.url.length).toLowerCase() === 'pdf' ? (
                          <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                            <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                          </div>
                              ) : (
                          <CardMedia
                            component="img"
                            alt="Imagem"
                            height="140"
                            image={this.state.image.url}
                            title="Imagem"
                          />
                              )
                            ) : (
                              this.state.image.error.length > 0 ? (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                              {this.state.image.error}
                            </Alert>
                          </div>
                              ) : (
                          <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                            <MuiAlert severity="info" variant="filled" elevation={0}
                              style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                            >
                              Nenhum arquivo anexado
                            </MuiAlert>
                          </div>
                              )
                            )
                          }

                          <Divider style={{marginTop: 10, marginBottom: 10}}/>
                        </CardActionArea>

                        {
                          this.state.image.url.length > 0 ? (
                        <CardActions>
                          <Button
                            size="small" color="primary"
                            onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                          >
                            Editar
                          </Button>
                        </CardActions>
                            ) : (
                        <CardActions>
                          <Button
                            size="small" color="primary"
                            onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                            disabled={this.state.disabledFields}
                          >
                            SELECIONAR
                          </Button>
                        </CardActions>
                            )
                          }

                      </Card>
                    </Grid>
                  </Grid>
                </div>
                  ) : ('') 
                }


                <DropzoneDialog
                  dialogTitle="Upload do arquivo"
                  cancelButtonText="CANCELAR"
                  submitButtonText="OK"
                  getFileAddedMessage={(fileName) => `Arquivo ${fileName} adicionado com sucesso.`}
                  open={this.state.dropzoneDialog}
                  onSave={this.fileToBase64.bind(this)}
                  acceptedFiles={['image/jpeg', 'image/png', 'image/jpg']}
                  showPreviews={true}
                  maxFileSize={5000000}
                  onClose={this.dropzoneDialogClose.bind(this)}
                  filesLimit={1}
                  dropzoneText="Clique ou arraste e solte um arquivo aqui"
                  previewText="Pré-visualização"
                  showAlerts={false}
                />
              </div>
            </Paper>
          </div>

          <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.msgErrorRequest}
            </MuiAlert>
          </Snackbar>

          <Snackbar open={this.state.successRequest} autoHideDuration={1000} onClose={this.successClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.successClose.bind(this)} severity="success" variant="filled" elevation={6}>
              {this.state.msgSuccessRequest}
            </MuiAlert>
          </Snackbar>
        </div>
      </MainLayout>
    );

  }

}

NovoVendedor.propTypes = {
  history: PropTypes.object
};

export default withRouter(NovoVendedor);